// FILE: src/Comman Components/UserName.js (FULLY UPDATED)
import React from 'react';
import { useSelector } from 'react-redux';

const getResolvedProfile = (profileDetails = {}) => {
  return (
    profileDetails.name ||
    profileDetails.username ||
    profileDetails.profile ||
    profileDetails.business_name ||
    null
  );
};

export default function UserName({ Id, fallbackName = null }) {
const profileDetails = useSelector(state => state.groups.profileDetails[Id]);
if (!Id) return <span className='font-bold text-red-500'>Unknown User</span>;
if (!profileDetails) return <span className='font-bold'>{fallbackName || 'Loading...'}</span>;
if (profileDetails.error) {
return (
<span className='font-bold text-yellow-600'>
{getResolvedProfile(profileDetails) || fallbackName || 'Profile Error'}
</span>
);
}
return <span className='font-bold'>{getResolvedProfile(profileDetails) || fallbackName || '...'}</span>;
}

export const FaceName = ({ Id, fallbackName = null }) => {
const profileDetails = useSelector(state => state.groups.profileDetails[Id]);
if (!Id) return <span className='font-bold text-red-500'>Unknown User</span>;
if (!profileDetails) return <span className='font-bold'>{fallbackName || 'Loading...'}</span>;
if (profileDetails.error) {
return (
<span className='font-bold text-yellow-600'>
{getResolvedProfile(profileDetails) || fallbackName || 'Profile Error'}
</span>
);
}
return <span className='font-bold'>{getResolvedProfile(profileDetails) || fallbackName || '...'}</span>;
};